module.exports = __webpack_public_path__ + "media/leipzig/overview-map-leipzig-0463d21e.svg";